import { render, staticRenderFns } from "./header-storage.vue?vue&type=template&id=5bf20c46&scoped=true"
import script from "./header-storage.vue?vue&type=script&lang=js"
export * from "./header-storage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf20c46",
  null
  
)

export default component.exports